import ORDERS from './ORDERS';
import TRANSFERS from './TRANSFERS';

const SCHEMA = [
  ORDERS, TRANSFERS
]

export default SCHEMA;

